class SubnavigationMarkup {
  constructor(config = {}) {
    const { header, linkClass} = config;
    this.body = document.querySelector("body");
    this.header = document.querySelector(header);

    this.lvl2Array = Array.prototype.slice.call(
      document.querySelectorAll(linkClass)
    );

    if (this.lvl2Array && this.lvl2Array.length > 0 && this.header) {
      this.bindEvents();
    }
  }

  bindEvents() {
    const template = this.buildTemplate(this.lvl2Array);

    this.header.after(template);

    // Call the function to check for active children
    this.addHasChildActiveClass();
  }

  addHasChildActiveClass() {
    // Get all top-level items
    const items = document.querySelectorAll('.subpageNavigation__item');

    items.forEach(item => {
      // Find if any child of the item has the "menu__item--active" class
      const activeChild = item.querySelector('.menu__item--active');

      if (activeChild) {
        // If found, add "has-child-active" class to the parent
        item.classList.add('has-child-link-active');
      }
    });
  }

  buildTemplate(allElement) {
    let templatePart = '';
    let allLinkTemplate = allElement.map((el) => {
      let anchorContent = el.querySelector('a');
      let linksLevel2 = Array.prototype.slice.call(
        el.querySelectorAll('.menu__item--level-2')
      );
      let templateLevel2 = (linksLevel2 && linksLevel2.length > 0) ? `<ul class="subpageNavigation__wrap-level2" tabindex="-1">${this.buildTemplateLevel2(linksLevel2)}</ul>` : '';
      templatePart = `<li class="subpageNavigation__item">
                          <a class="subpageNavigation__link" href="${anchorContent.href}">
                              ${anchorContent.innerHTML}
                          </a>
                            ${templateLevel2}
                      </li>`;
      return templatePart;
    }).join('');

    let masterTemplateOrIDontknowHowtoCallThisShit = `<nav class="subpageNavigation">
                                                        <div class="subpageNavigation__wrap">
                                                            <div class="subpageNavigation__items-wrap">
                                                                <ul class="subpageNavigation__items">
                                                                  ${allLinkTemplate}
                                                                </ul>
                                                                <i class="subpageNavigation__hover" data-subpage-navigation="hover"></i>
                                                            </div>
                                                        </div>
                                                      </nav>`;

    return this.createFragment(masterTemplateOrIDontknowHowtoCallThisShit);
  }

  buildTemplateLevel2(allLinks) {
    let templatePart = '';
    let allLinkTemplateLebel2 = allLinks.map((el) => {
      let classes = 'subpageNavigation__item-level2';
      if(el.classList.contains('menu__item--has-children')) classes += ' menu__item--has-children';
      templatePart = `<li class="${classes}">
                        ` + el.innerHTML + `
                      </li>`;
      return templatePart;
    }).join('');
    return allLinkTemplateLebel2;
  }

  createFragment(markup) {
    const fragment = document.createRange().createContextualFragment(markup);
    return fragment.firstChild;
  }
}


export default SubnavigationMarkup;
